"use client";

import React from "react";
import { MapPin, Phone, Navigation, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServingCoralSprings() {
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223680" id="local-service-area" className="relative w-full min-h-[600px] flex items-center bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645714/img/kansas_city_metro_it_map.png)] bg-cover bg-center bg-no-repeat grayscale opacity-40 mix-blend-luminosity" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/40 to-transparent !bg-[url(https://settling-osprey.10web.cloud/wp-content/uploads/2026/04/kansas_city_industrial_map.png)]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={cardRef} className={`max-w-md transition-all duration-1000 ease-out ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="bg-card/90 backdrop-blur-xl border-border/50 shadow-4xl overflow-hidden">
            <CardHeader className="pb-4">
              <Badge variant="secondary" className="w-fit mb-3 bg-primary text-primary-foreground font-mono uppercase tracking-widest">
                Kansas City Metro
              </Badge>
              <CardTitle className="text-3xl font-default text-foreground font-bold">
                Local Field Execution
              </CardTitle>
              <CardDescription className="text-base font-sans text-muted-foreground mt-2">We are on-site within hours, not days. Serving SMBS, and IT Partners, delivering excellent service across the entire KC region.</CardDescription>
            </CardHeader>

            <CardContent className="space-y-5 pb-6">
              <div className="flex items-start gap-4">
                <div className="mt-1 bg-primary/20 p-2 rounded-sm shrink-0">
                  <MapPin className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-foreground">
                    Regional Hub
                  </h4>
                  <p className="text-muted-foreground font-sans mt-1 leading-relaxed">
                    Overland Park, Olathe,
                    <br />
                    KCMO, & Liberty
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="mt-1 bg-primary/20 p-2 rounded-sm shrink-0">
                  <Phone className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-foreground">
                    Rapid Dispatch
                  </h4>
                  <p className="text-muted-foreground font-sans mt-1">(913) 636-8169</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="mt-1 bg-primary/20 p-2 rounded-sm shrink-0">
                  <Clock className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-foreground">
                    Response Time
                  </h4>
                  <p className="text-muted-foreground font-sans mt-1">
                    4-Hour SLA Available
                  </p>
                </div>
              </div>
            </CardContent>

            <CardFooter className="pt-2 pb-6">
              <Button asChild size="lg" className="w-full group bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm">
                <Link to="#">
                  <Navigation className="w-4 h-4 mr-2 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                  Request Site Survey
                </Link>
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}